import React from 'react';
import {
  Container,
  Grid,
  Header,
  Icon,
  Segment,
} from 'semantic-ui-react';
import { getImageUrl } from '../../../utils/images';


interface FeatureItem {
  icon?: string;
  title?: string;
  text?: string;
}

interface FeaturesViewData {
  backgroundImage?: string | null;
  items?: FeatureItem[];
}

interface FeaturesViewProps {
  data?: FeaturesViewData;
}

const FeaturesView = ({ data = {} }: FeaturesViewProps) => {
  const {
    backgroundImage = null,
    items = [],
  } = data;

  const imageUrl = getImageUrl(backgroundImage);

  return (
    <section
      className="features-block fullbleed"
      style={{
        backgroundImage: `url(${imageUrl})`,
        backgroundPosition: 'center center',
      }}
    >
      <Container>
        <Grid padded stackable>
          <Grid.Row>
            <Grid.Column widescreen={2} largeScreen={2} only="computer tablet" />
            <Grid.Column widescreen={7} largeScreen={8} tablet={10} mobile={16}>
              <div className="features-list">
                {items.map((item, idx) => (
                  <Segment
                    key={idx}
                    basic
                    className="feature-card"
                  >
                    <div className="feature-row">
                      <Icon
                        name={item.icon as any || 'wrench'}
                        size="large"
                        className="feature-icon"
                      />
                      <div className="feature-content">
                        <Header
                          as="h3"
                          className="feature-title"
                          dividing
                        >
                          {item.title}
                        </Header>
                        <p className="feature-text">
                          {item.text}
                        </p>
                      </div>
                    </div>
                  </Segment>
                ))}
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </section>
  );
};

export default FeaturesView;